var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 42,
  width: 42,
  viewBox: "-1 -1 42 42",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Play")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#001E62",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 10l13 10-13 10V14.784"
}))));
export default SvgPlay;